import { render, staticRenderFns } from "./BBCheckbox.vue?vue&type=template&id=f0ae4572"
import script from "./BBCheckbox.vue?vue&type=script&lang=js"
export * from "./BBCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports